import React, { useEffect } from "react";
import LedgerPageDashboardActive from "./LedgerPageDashboardActive";
import { useDispatch, useSelector } from "react-redux";
import { fetchActiveConnection } from "../../../Redux/Slices/CapacitySlice";
import { useLocation } from "react-router-dom";

const OngoingConnections = ({ type, capacityId }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  let capId = location?.search?.split("=")[1];

  useEffect(() => {
    if ((type === "RA_ONGOING" || type === "RA_ACTIVE") && !capacityId) return;

    dispatch(
      fetchActiveConnection({
        curr: 0,
        capId:
          type === "RA_ONGOING" || type === "RA_ACTIVE" ? capacityId : capId,
      })
    );
  }, [dispatch, capId, capacityId, type]);

  const aa = useSelector((state) => state?.activeSubTabSlice?.activeSubTab);

  return (
    <>
      <LedgerPageDashboardActive
        viewType={
          type === "RA_ONGOING" || type === "RA_ACTIVE" ? "RA_TERMS" : ""
        }
        activeSubTab={aa}
        setActiveSubTab={() => {}}
        capacityId={capacityId}
      />
    </>
  );
};

export default OngoingConnections;
